// User auth bundle (login, password forgot, password reset)
import '../css/vendor/jquery.passwordRequirements.css';
import '../css/pages/password-forgot.css';
import '../css/pages/password-reset.css';

import { runLegacy } from './helpers/load-legacy';
import passwordRequirementsJs from '../js/vendor/jquery.passwordRequirements.js?legacy';
import loginProcessJs         from '../js/global/login-process.js?legacy';
import passwordJs             from '../js/global/password.js?legacy';
import passwordResetJs        from '../js/vendor/password-reset.js?legacy';

runLegacy(
    passwordRequirementsJs,
    loginProcessJs,
    passwordJs,
    passwordResetJs,
);
